
   <sm-title-bar  pageTitle="Notifications" *ngIf="!loader">
   
  </sm-title-bar>
   <div  *ngIf="!loader">
   
     <div class="row" *ngIf="messageLIst.length > 0 && !loader">
       <div class="col-sm-8">
        <mat-card class="open_trt">
        <div class="fl_orders"  *ngFor="let item of messageLIst">
           <div class="top_section_order">
             <div class="row">
               <div class="col-sm-1" style="padding-right: 0px;">
                 <!-- <div class="ads_sec">
                   <div
                     class="hm_icon_progr"
                     *ngIf="
                       item.senderImgThumbUrl && item.senderImgThumbUrl != 'null'">
                     <img [src]="item.senderImgThumbUrl" />
                   </div>
                   <div
                     class="hm_icon_progr"
                     *ngIf="
                       !item.senderImgThumbUrl ||
                       item.senderImgThumbUrl == 'null'
                     "
                   >
                     <img src="../../../../assets/images/photo.png" />
                   </div>
                 </div> -->
                     <div class="notif-image">
                <img *ngIf="(item.senderImgThumbUrl && item.senderImgThumbUrl != 'null') && (item.notifyType != 'onBusinessActivation' && item.notifyType != 'adminMessage')" [src]="item.senderImgThumbUrl" />
                <img *ngIf="item.notifyType == 'onBusinessActivation' || item.notifyType == 'adminMessage'" src="../../../../assets/images/app_icon.png" />
                <div class="booking-initial" *ngIf="(!item.senderImgThumbUrl || item.senderImgThumbUrl == 'null') && (item.notifyType != 'onBusinessActivation' && item.notifyType != 'adminMessage')"><mat-icon class="not_icn">notifications</mat-icon></div>
                <!-- <div class="booking-initial" *ngIf="item.notifyType == 'onBusinessActivation' || item.notifyType == 'adminMessage'"><mat-icon class="not_icn">notifications</mat-icon></div> -->
                <!-- <img *ngIf="!item.senderImgThumbUrl || item.senderImgThumbUrl == 'null'" src="../../../../assets/images/photo.png" /> -->
              </div>
               </div>
               <div class="col-sm-11" style="padding-left: 0px">
                 <div class="order_dec">
                   <div class="tick_opklads">
                     <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                     <!-- <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon -->
                     {{ item.creationDate | date:'MMM d, y - h:mm a' }}
                   </div>
                   <h3
                     style="
                       -webkit-box-orient: vertical;
                       display: -webkit-box;
                       -webkit-line-clamp: 1;
                       overflow: hidden;
                       text-overflow: ellipsis;
                       white-space: normal;
                       margin-bottom: 0px;
                       font-size: 16px;
                     "
                   >
                     {{ item.title }}
                   </h3>
                   <p>
                     {{ item.description }}
                     <!-- </p>
                                   <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                   </p>
                                   <p>Approx Time: {{item.approxTime}} minutes
                                   </p> -->
                     <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                     <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                   </p>
                 </div>
               </div>
             </div>
           </div>
        
         </div>
        </mat-card>
       </div>
     </div>
    
     <div class="row" *ngIf="messageLIst.length == 0 && !loader">
       <div class="col-sm-12" >
         <div style="padding: 20px 18px 20px 18px;
         background: var(--color-primary-contrast);
         border-radius: var(--dra-radius-x-small);transition: 0.3s;">
           <div class="top_section_order">
             <div class="row">
              <div class="nal_rrty">
               <div style="text-align:center;min-height: 500px;padding-top: 210px">
               <div class="cv_notifia">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M12 21.75a2.731 2.731 0 0 1-2.378-1.372.75.75 0 0 1 1.3-.756 1.287 1.287 0 0 0 2.164 0 .75.75 0 1 1 1.3.756A2.731 2.731 0 0 1 12 21.75zm8.675-3.425a.751.751 0 0 0-.089-.793 9.219 9.219 0 0 1-1.841-5.032V8.995a6.745 6.745 0 0 0-13.49 0V12.5a9.219 9.219 0 0 1-1.841 5.032A.751.751 0 0 0 4 18.75h16a.75.75 0 0 0 .675-.425zM6.755 12.5V8.995a5.245 5.245 0 0 1 10.49 0V12.5a9.908 9.908 0 0 0 1.368 4.75H5.387a9.908 9.908 0 0 0 1.368-4.75z" fill="#b1b1b1" opacity="1" data-original="#000000" class=""></path></g></svg>
               </div>
               <div>
                 <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">Notifications will be shown here as <br/> they arrive.
                </p>
              </div>
               </div>
             </div>
            </div>
           </div>
         </div>
       </div>
     </div>
  
 </div>
 